<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Purchase",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, Loader },
  data() {
    return {
      title: "Record Production",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Purchase",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "selling_price",
          sortable: true,
          label: "SELLING PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      itemError: "",
      quantityError: "",
      priceError: "",
      modeError: "",
      unitError: "",
      totals: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        total: 0,
        total_brand: 0,
        cost_price: 0,
        product: '',
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        product: "",
        quantity: "",
        unit_price: "",
        selling_price: 0,
        is_brand: 0,
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      item_rate:0
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("consumables", ["Consumables"]),
    ...mapGetters("production", ["ProductionCart", "SaveStatus"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionCart ? this.ProductionCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductionCart ? this.ProductionCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchConsumables",
      FetchProductionCart: "production/fetchProductionCart",
      AddCart: "production/addToProductionCart",
      DeleteCartItem: "production/deleteProductionCart",
      EditCartItems: "production/editProductionCart",
      SaveBatch: "production/saveProduction",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchItems: "products/fetchProducts",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editPriceCommas() {
      this.editdata.unit_price = this.editdata.unit_price?this.thousandSeprator(this.editdata.unit_price):0;
      this.editdata.selling_price = this.editdata.selling_price?this.thousandSeprator(this.editdata.selling_price):0;
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.unit_price = "";
      this.editdata.selling_price = "";
      this.editdata.is_brand = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.priceError = "";
      this.unitError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.item.id;
      this.editdata.name = data.item.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.expiry = data.expiry;
      this.editdata.batch = data.batch;
      this.editdata.is_brand = data.item.is_brand;
      this.editdata.unit_price = this.thousandSeprator(data.unit_price);
      this.editdata.selling_price = this.thousandSeprator(data.selling_price);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveBatch() {
      this.SaveBatch(this.totals);
      this.totals.paid = 0;
    },
    addToCart() {
      this.AddCart();
    },
    paidCommas() {
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas() {
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetErrors();
      });
    },

    resetPaidError() {
      this.PaidError = "";
    },

    updateTotals() {
      let totalAmount = 0;
      let totalBrand = 0;
      let totalQuantity = 0;
      // let totalCost = 0;
      let costPrice = 0;
      this.ProductionCart.forEach((item) => {
        totalAmount += parseInt(item.unit_price * item.quantity, 10);
        totalBrand += parseInt(item.selling_price * item.quantity, 10);

        if (item.is_final_product > 0) {
          totalQuantity += parseInt(item.quantity, 10);
        }
      });

      this.totals.total = totalAmount;
      this.totals.total_brand = totalBrand;

      if (totalQuantity > 0) {
        costPrice = (totalAmount - totalBrand) / totalQuantity;
      }

      this.totals.cost_price = costPrice;
      
    },
  },
  updated() {
    if (this.ProductionCart) {
      let totalAmount = 0;
      let totalBrand = 0;
      let totalQuantity = 0;
      let costPrice = 0;

      this.ProductionCart.forEach((item) => {
        totalAmount += item.unit_price * item.quantity; // Avoid parseInt here
        totalBrand += item.selling_price * item.quantity;

        if (item.item.is_final_product && item.item.is_product == 0) {
          totalQuantity += item.quantity; // Avoid parseInt here
        }
      });

      this.totals.total = totalAmount;
      this.totals.total_brand = totalBrand;

      if (totalQuantity > 0) {
        costPrice = Math.round((totalAmount - totalBrand) / totalQuantity); // Accurate rounding
      }

      this.totals.cost_price = costPrice;
    }
  },

  watch: {
    ProductionCart(newValue) {
      if (newValue) {
        // this.updateTotals();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    Products(newValue){
      if(newValue){
        let pdts = this.Products.filter((item) => {
          return item.mainstock == 1;
        });
        this.totals.product = pdts[0].id;
      }
    }
  },
  created() {
    this.FetchConsumables();
    this.FetchProductionCart();
    this.FetchGeneralSettings();
    this.FetchItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title mb-4">Items in Cart</h4>
              </div>
              <div class="col-4">
                <b-button v-if="SaveStatus" variant="primary"
                  disabled><i class="fa fa-plus"></i> Add Items
                  <b-spinner                    
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
                <b-button v-else @click="addToCart()" variant="primary"
                  ><i class="fa fa-plus"></i> Add Items
                </b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ProductionCart ? ProductionCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unit_price
                      ? thousandSeprator(
                          data.item.quantity * data.item.unit_price
                        )
                      : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{
                    data.item.unit_price
                      ? thousandSeprator(data.item.unit_price)
                      : 0
                  }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }}
                  {{ data.item.unit.unitsym }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i
                  > Update</b-button>
                  <b-button
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i
                  > Delete</b-button>
                </template>
              </b-table>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ProductionCart" />
            <div class="row" v-if="totals.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong>TOTAL: {{ thousandSeprator(totals.total) }}/=</strong>
                </h4>
                <h4>
                  <strong
                    >TOTAL BRAND:
                    {{ thousandSeprator(totals.total_brand) }}/=</strong
                  >
                </h4>
                <h4>
                  <strong
                    >AVERAGE COST:
                    {{ thousandSeprator(totals.cost_price) }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="totals.total > 0">
              <div class="row">
                <div class="form-group col-md-4" v-if="GeneralSettings.use_ingredients == 1">
                  <label>Output</label>
                  <model-list-select
                      :list="Products ? Products : []"
                      v-model="totals.product"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Product"
                  >
                  </model-list-select>
                </div>

                <div class="form-group col-md-6">
                  <label>Production Date <span class="text-danger">*</span></label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="totals.date"
                    placeholder="Enter Date"
                    v-limit-future-date
                  />
                </div>
                <div
                  v-if="MyUserPerm.stocking_consumables == 1 && SaveStatus"
                  class="col-md-4 mt-4"
                >
                  <b-button variant="primary" class="pull-center" disabled
                    ><i class="fa fa-check"></i> Saving Batch
                    <b-spinner variant="light" label="Spinning"></b-spinner>
                  </b-button>
                </div>
                <div
                  v-if="MyUserPerm.stocking_consumables == 1 && !SaveStatus"
                  class="col-md-4 mt-4"
                >
                  <b-button
                    variant="primary"
                    class="pull-center"
                    @click="saveBatch()"
                    ><i class="fa fa-check"></i> Save Batch
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal
      id="edit-item-modal"
      class="text-primary"
      hide-footer
      @hidden="resetEdit()"
    >
      <template #modal-title> Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input
          type="text"
          class="form-control"
          step="any"
          v-model="editdata.unit_price"
          @input="editPriceCommas()"
        />
      </div>
      <div class="form-group mb-3" v-if="editdata.is_brand == 1">
        <label>Selling Price</label>
        <input
          type="text"
          class="form-control"
          step="any"
          v-model="editdata.selling_price"
          @input="editPriceCommas()"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal
      id="delete-item-modal"
      class="text-danger"
      hide-footer
      @hidden="resetDeleteItem"
    >
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>